import { Serializer } from 'jsonapi-serializer';
import { UserSettingsUpdate } from '../interfaces/user-settings-update.interface';

const serializer = new Serializer('Settings', {
	attributes: ['format', 'language', 'theme'],
	format: {
		attributes: ['date', 'number', 'time'],
	},
});

export function serializeUserSettings(settings: UserSettingsUpdate) {
	return serializer.serialize({ ...settings, language: settings.lang });
}
